export default {
  'name': '姓名',
  'email': '邮箱',
  'website': '网址',
  'companyName': '公司名称',
  'mobile': '电话',
  'createTime': '提交时间',
  'operation': '操作',
  'del': '删除',
  'details': '更多详情',

  'num': '场次',
  'title': '标题',
  'description': '描述',
  'startTime': '开始时间',
  'endTime': '结束时间',
  'deadline': '	报名截止时间',
  'place': '地点',
  'sort': '排序号',
  'status': '审核状态',
  'reason': '原因',
  'createTimeActor': '报名时间',
  'boothNum': '展位号',

  'businessNature':'商业性质',
  'productImg': '产品图',
  'certificates': '证书',
  'purchaseQuantity': '采购数量',
  'unit': '采购数量单位',
  'suppliersBusinessNature': '供应商业务性质',
  'suppliersScale': '供应商规模',
  'suppliersRegion': '供应商区域',
  'other': '其他备注',
  'expectedDate': '预期约见日',
  'answers': '标签',
  'Tips': '此操作将永久删除该信息, 是否继续?',
  'Deletion cancelled': '已取消删除',
  'Registration Info': '报名信息',

  'procurementStartTime': '请选择开始时间',
  'procurementEndTime': '请选择结束时间',

  'pleaseEnter': '请按照采购对接标题进行搜索',

}
